import Cookies from 'js-cookie';

import { IS_WHITE_LABEL } from '@/shared/environments';
import { isTrackingDisabled } from '@/shared/lib/isTrackingDisabled';

export const OPENAI_ADS_CONSENT_EVENTS = [
  'CookiebotOnConsentReady',
  'CookiebotOnAccept',
  'CookiebotOnDecline',
] as const;

const readyConsent = new WeakSet<object>();
OPENAI_ADS_CONSENT_EVENTS.forEach((name) => {
  window.addEventListener(name, () => {
    if (window.Cookiebot) readyConsent.add(window.Cookiebot);
  });
});

export type OpenAiAdsContext = {
  marketing_consent: boolean;
  obref?: string;
  observed_at: string;
  oppref?: string;
};

export const getOpenAiAdsContext = (): OpenAiAdsContext | undefined => {
  const observed_at = new Date().toISOString();
  if (IS_WHITE_LABEL || isTrackingDisabled()) {
    return { marketing_consent: false, observed_at };
  }
  const cookiebot = window.Cookiebot;
  if (!cookiebot?.consent || (!cookiebot.hasResponse && !readyConsent.has(cookiebot))) return;
  if (!cookiebot.consent.marketing) {
    return { marketing_consent: false, observed_at };
  }
  const oppref = new URLSearchParams(window.location.search).get('oppref') || Cookies.get('__oppref');
  const obref = Cookies.get('__obref');
  return {
    marketing_consent: true,
    observed_at,
    ...(oppref && oppref.length <= 2048 && { oppref }),
    ...(obref && obref.length <= 256 && { obref }),
  };
};
